











import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { StandardOption } from "../../../system/selectors/mixins";

/* 
 * - PropertyEditorの形に合わせに縦方向に項目が並ぶようにする
 * - ラジオボタンのように動作するがチェックを外すことができる必要がある（入力不可に切り替えることができるもの）。
 */

@Component
export default class ObjectMenuButton extends Mixins(ModelEditableMixin) {
  @Prop()
  option: StandardOption<any>;

  @Prop()
  buttonClass: string; // ボタン名称.
}
